import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ProductsRoutingModule} from './products-routing.module';
import {ProductsComponent} from './products/products.component';
import {ProductComponent} from './product/product.component';
import {WidgetsModule} from '../../widgets/widgets.module';
import {TranslateModule} from '@ngx-translate/core';
import {BoxesModule} from '../../boxes/boxes.module';
import {SwiperModule} from 'ngx-swiper-wrapper';
import {PipesModule} from '../../providers/pipes/pipes.module';
import {DirectivesModule} from '../../providers/directives/directives.module';
import {ProductFooterComponent} from './partials/product-footer/product-footer.component';
import {ProductKitModule} from '../../components/product-kit/product-kit.module';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {LayoutModule} from '../../layout/layout.module';
import {ProductWarrantyBannerComponent} from './partials/product-warranty-banner/product-warranty-banner.component';


@NgModule({
  declarations: [ProductsComponent, ProductComponent, ProductFooterComponent, ProductWarrantyBannerComponent],
  imports: [
    CommonModule,
    ProductsRoutingModule,
    WidgetsModule,
    TranslateModule,
    BoxesModule,
    SwiperModule,
    PipesModule,
    DirectivesModule,
    ProductKitModule,
    NgbModalModule,
    ReactiveFormsModule,
    LayoutModule
  ]
})
export class ProductsModule {
}
